import React from "react";
import { useNavigate } from "react-router-dom";
import {ReactComponent as DebitSvg} from './../assets/icons/svg/debit.svg';
import {ReactComponent as CreditSvg} from './../assets/icons/svg/credit.svg';
import {currencyConverter} from './../utils/index';

export default function ListTransaction({data, notarrow}) {
   const navigate = useNavigate();

   const formatDate = (date) => {
      let d = new Date(date);
      let day = d.getDate();
      let strArray=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      let month = strArray[d.getMonth()];
      let year = d.getFullYear();
      let time = d.getHours() + ':' + d.getMinutes();
      return day + ' ' + month + ' ' + year + ' ' + time + ' WIB';


   };

   return (
      <div className="d-flex align-items-center justify-content-between py-3">
         <div className="d-flex align-items-center">
            <div className="item-transaction-icon me-4">
               {data?.type === 'credit' ? <CreditSvg/> : <DebitSvg/> }
            </div>
            <div className="item-transaction-activities ts-md">
               <div className="text-body mb-1 fw-semibold">{data?.name}</div>
               <small className="text-muted ts-sm">
                  {formatDate(data?.created_at)}
               </small>
            </div>
         </div>
         <div className="d-flex align-items-center">
            <div className="item-transaction-amount text-end">
               <div className={data?.type === 'credit' ? 'text-danger fw-semibold ts-md' : 'text-success fw-semibold ts-md'}>
               {data?.type === 'credit' ? '-' : '+'}{currencyConverter(data?.total_amount)}
               </div>
               <small className="text-muted ts-sm">{data?.partner?.name}</small>
            </div>
            {notarrow ? null : <i className="ph-caret-right ms-3 fw-bold text-dark"></i>}
         </div>
      </div>
   );
}